import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { setLenis } from "@/lib/scroll";
import { LanguageContext, translations } from "@/constants/i18n";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import About from "@/components/landing/About";
import Iul from "@/components/landing/Iul";
import Credentials from "@/components/landing/Credentials";
import Testimonials from "@/components/landing/Testimonials";
import Faq from "@/components/landing/Faq";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import MobileCta from "@/components/landing/MobileCta";
import AdminPage from "@/pages/AdminPage";
import ReviewPage from "@/pages/ReviewPage";

const Landing = () => (
    <div className="min-h-screen bg-ivory font-sans text-ink antialiased">
        <Navbar />
        <main>
            <Hero />
            <Marquee />
            <About />
            <Iul />
            <Credentials />
            <Testimonials />
            <Faq />
            <Contact />
        </main>
        <Footer />
        <MobileCta />
    </div>
);

export default function App() {
    const [lang, setLangState] = useState(
        () => localStorage.getItem("fp-lang") || "es"
    );

    const setLang = (l) => {
        localStorage.setItem("fp-lang", l);
        setLangState(l);
    };

    useEffect(() => {
        document.documentElement.lang = lang;
    }, [lang]);

    useEffect(() => {
        const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
        setLenis(lenis);
        let rafId;
        const loop = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(loop);
        };
        rafId = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return (
        <LanguageContext.Provider value={{ lang, setLang, t: translations[lang] }}>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/admin" element={<AdminPage />} />
                    <Route path="/resena" element={<ReviewPage />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
        </LanguageContext.Provider>
    );
}
